import { get, Response } from '@/api'
import { Category } from '@/generatedTypes'

export const CATEGORIES_ENDPOINT = '/categories'

export default {
  loadCategories: (): Promise<Response<Category[]>> => {
    return get<Category[]>(CATEGORIES_ENDPOINT)
  }
}
